import React, { useState } from 'react';
import { ButtonContainer, defaultButtonStyles, Paragraph, Strong } from '../../theme';
import { Dialog, DialogContent, DialogContentText, Button } from '@mui/material';
import PPOCardImage from '../../assets/images/PPOInsuranceCard.png';
import HMOCardImage from '../../assets/images/HMOInsuranceCard.png';
import EPOCardImage from '../../assets/images/EPOInsuranceCard.png';
import POSCardImage from '../../assets/images/POSInsuranceCard.png';
import { ModalProps } from '../../utils/types';
import CloseIcon from './CloseIcon';

const NotSureNetworkModal = ({ open, handleClose }:ModalProps): JSX.Element => {
    const [ card, setCard ] = useState(PPOCardImage);
    return (
        <Dialog
            maxWidth='md'
            fullWidth={true}
            open={open}
            onClose={handleClose}
        >
            <DialogContent sx={{ padding: '35px' }}>
                <CloseIcon handleClose={handleClose}/>
                <DialogContentText>
                    <Paragraph style={{ textAlign: 'center' }}><Strong>Check out these example cards and look at your own for the following</Strong></Paragraph>
                    <ButtonContainer>
                        <Button className={card === PPOCardImage ? 'active' : ''} sx={defaultButtonStyles} variant='outlined' onClick={() => { setCard(PPOCardImage); }}>PPO</Button>
                        <Button className={card === HMOCardImage ? 'active' : ''} sx={defaultButtonStyles} variant='outlined' onClick={() => { setCard(HMOCardImage); }}>HMO</Button>
                        <Button className={card === EPOCardImage ? 'active' : ''} sx={defaultButtonStyles} variant='outlined' onClick={() => { setCard(EPOCardImage); }}>EPO</Button>
                        <Button className={card === POSCardImage ? 'active' : ''} sx={defaultButtonStyles} variant='outlined' onClick={() => { setCard(POSCardImage); }}>POS</Button>
                    </ButtonContainer>
                    <img src={card} style={{ width: '100%', maxWidth: '500px', margin: '0 auto', display: 'flex' }}/>
                </DialogContentText>
            </DialogContent>
        </Dialog>
    );
};

export default NotSureNetworkModal;
